import { render } from "./EnvironmentWatermark.vue?vue&type=template&id=b5d4ffb0&scoped=true"
import script from "./EnvironmentWatermark.vue?vue&type=script&lang=js"
export * from "./EnvironmentWatermark.vue?vue&type=script&lang=js"

import "./EnvironmentWatermark.vue?vue&type=style&index=0&id=b5d4ffb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d4ffb0"]])

export default __exports__